/* global edacpFullSiteScanApp */
let debug = false;

if ( typeof edacpFullSiteScanApp !== 'undefined' ) {
	debug = edacpFullSiteScanApp.debug === '1';
}

export const settings = {
	JS_SCAN_ENABLED: true,
	INFO_ENABLED: debug,
	DEBUG_ENABLED: debug,
};
